import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import LanguageSelect from '../LanguageSelect';
import { useHistory, useLocation } from 'react-router-dom';
import Button from '../Form/Toolbar/Button';
import { States } from '../../features/PpsiContainer/constants';
import { Mode, modePropType } from './constants';
import PublishedInstructionLink from './PublishedInstructionLink';
import PpsiIfoodDiscontinueText from './PpsiIfoodDiscontinueText';
import MoreMenu from '../Form/Toolbar/MoreMenu';
import MoreMenuItem from '../Form/Toolbar/MoreMenuItem';
import {
  getConfigs,
  getIsDataDirty,
  getCallback
} from '../../features/app/selectors';

import { getIsGlobalUser } from 'features/loginSystem/selectors';
import GlobalPpsiDiscontinueText from './GlobalPpsiDiscontinuedText';
import { ppsiCreateVariantRoute } from 'routes';
import { notify } from 'features/notificationSystem/actions';
import displayText from './displayText.json';
import useQueryParams from 'utils/useQueryParams';

const PpsiToolbarContent = ({
  data,
  mode,
  onSave = () => {},
  onApprove = () => {},
  onPublish = () => {},
  onPublishEmptyPpsi = () => {},
  onUnpublish = () => {},
  onCreateDraft = () => {},
  oniFoodUpdatePpsi = () => {},
  onGlobalUpdatePpsi = () => {},
  onSubmitForReview = () => {},
  setOpenConfirm = () => {},
  onGlobalApprovePpsi = () => {},
  onGlobalRejectPpsi = () => {},
  completePpsiData
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isDataDirty = useSelector(getIsDataDirty);
  const getConfigData = useSelector(getConfigs).toJS();
  const callback = useSelector(getCallback);
  const isGlobalUser = useSelector(getIsGlobalUser);
  const [localPpsiCopy] = useQueryParams('localPpsiCopy');

  function inStatus(...status) {
    return status.includes(data.status);
  }

  function findDuplicates(arr, key) {
    const seen = new Set();
    const duplicates = [];

    for (const item of arr) {
      const keyValue = item[key];
      if (seen.has(keyValue)) {
        duplicates.push(item);
      } else {
        seen.add(keyValue);
      }
    }

    return duplicates;
  }

  let duplicatedPpis = [];
  if (data && data.referencedIFoodData) {
    duplicatedPpis = findDuplicates(
      data.referencedIFoodData.referencedIngredientEntities,
      'itemCode'
    );
  }

  const updateCategoryList =
    getConfigData &&
    getConfigData.updateCategory
      .map(item => item.enum)
      .filter(i => i !== 'IFOOD_UPDATE');

  const sentForReview =
    data && data.status === 'DRAFT' && data.parentPpsiId !== null;

  const updateCategory =
    data.updateNotificationList !== undefined
      ? data.updateNotificationList.length > 0
        ? data.updateNotificationList.map(i => i.category)
        : []
      : [];
  const displayCategory =
    updateCategory.length > 0 ? [...new Set(updateCategory)] : [];

  // from line no- 59 to 69 codes added for JIRA card no IFPPSI - 361
  const iFoodDiscontinuedItems =
    data.updateNotificationList !== undefined &&
    data.updateNotificationList.length > 0 &&
    data.updateNotificationList.filter(i => i.category === 'IFOOD_UPDATE');

  const iFoodDiscontinued =
    iFoodDiscontinuedItems.length > 0 &&
    iFoodDiscontinuedItems.map(i => i.message);

  const disableIfoodImportButton =
    iFoodDiscontinued.length > 0 &&
    iFoodDiscontinued.includes(
      'This dish is no longer available. This dish is Discontinued'
    );
  //&&
  //!inStatus(States.PUBLISHED);

  const isItemDiscontinued = displayCategory.includes(
    'GLOBAL_PPSI_DISCONTINUED'
  );

  const disableEditInstructionBtn =
    isItemDiscontinued ||
    (iFoodDiscontinued.length > 0 &&
      iFoodDiscontinued.includes(
        'This dish is no longer available. This dish is Discontinued'
      ));

  const iFoodDiscontinuedMessage =
    iFoodDiscontinued.length > 0 &&
    iFoodDiscontinued.includes(
      'This dish is no longer available. This dish is Discontinued'
    );

  const checkStatus =
    inStatus(States.GLOBALAPPROVED, States.SCHEDULED) &&
    disableIfoodImportButton;
  const ifoodDiscontinue = inStatus(States.GLOBALREJECTED, States.DRAFT);

  const displayiFoodImportButton = displayCategory.includes('IFOOD_UPDATE');
  const displaySaveButton =
    displayCategory.length > 0 && (ifoodDiscontinue || checkStatus);
  // const displaySaveButton = displayCategory.includes('IFOOD_UPDATE') && inStatus(States.GLOBALAPPROVED) !== true;

  const displayGlobalButton =
    displayCategory.length > 0 && !displayiFoodImportButton;
  const deactivateGlobalButton = displayGlobalButton && isItemDiscontinued;

  const isDiscardScheduled =
    (iFoodDiscontinuedMessage || isItemDiscontinued) &&
    inStatus(States.SCHEDULED);

  const isiFoodUpdateBtnVisible = () => {
    if (
      displayiFoodImportButton &&
      data.upToDate === false &&
      (inStatus(States.DRAFT) === true ||
        inStatus(States.GLOBALREJECTED) === true)
    ) {
      return true;
    }
    return false;
  };

  const isGlobalUpdateBtnVisible = () => {
    if (
      displayGlobalButton &&
      data.upToDate === false &&
      (inStatus(States.DRAFT) === true ||
        inStatus(States.GLOBALREJECTED) === true)
    ) {
      return true;
    }
    return false;
  };

  const marketLanguage = data.status === 'GLOBAL REVIEW' && isGlobalUser;
  const globalReject = data.status === 'GLOBAL REJECTED' && !isGlobalUser;
  const globalApprove = data.status === 'GLOBAL APPROVED' && !isGlobalUser;

  const notShowMessage = !inStatus(
    States.GLOBALAPPROVED,
    //States.PUBLISHED,
    isGlobalUser ? States.GLOBALREVIEW : ''
  );

  const showGlobalMessage = !inStatus(States.GLOBALAPPROVED);
  const displayPublishedLabel = () => {
    // importUpdates changes
    // console.log(completePpsiData,data)
    if (inStatus(States.PUBLISHED, States.UNPUBLISHED)) {
      const hasInProgressVersion = !!completePpsiData.inProgressPpsiEnrichmentData;
      if (hasInProgressVersion) {
        return 'form.goToDraft';
      }
    }
    return 'form.createDraftPpiLabel';
  };

  if (
    isDataDirty &&
    callback &&
    // (mode === Mode.CREATE || inStatus(States.DRAFT))
    (mode === Mode.CREATE ||
      inStatus(States.DRAFT) ||
      inStatus(States.GLOBALREJECTED))
  ) {
    onSave(data, callback);
    return null;
  }

  // isUpToDate

  function createVariant() {
    if (iFoodDiscontinuedMessage) {
      dispatch(
        notify({
          message:
            'Failed to create variant of Dish instruction. Reason: Dish is discontinued in iFood!',
          variant: 'error'
        })
      );
    } else if (isItemDiscontinued) {
      dispatch(
        notify({
          message:
            'Failed to create variant of Dish instruction. Reason: Global discontinued the dish!',
          variant: 'error'
        })
      );
    } else if (data.isUpToDate === false && displayiFoodImportButton) {
      dispatch(
        notify({
          message:
            'Failed to create variant of Dish instruction. Reason: PPSI is not up to date with iFood!',
          variant: 'error'
        })
      );
    } else if (
      data.isUpToDate === false &&
      !displayiFoodImportButton &&
      displayCategory.length > 0
    ) {
      dispatch(
        notify({
          message:
            'Failed to create variant of Dish instruction. Reason: PPSI is not up to date with parent PPSI',
          variant: 'error'
        })
      );
    } else {
      history.push(
        ppsiCreateVariantRoute(data.ppsiId, data.dish.formulaCode, data.status)
      );
    }
  }

  return (
    <>
      {disableIfoodImportButton &&
        // showGlobalMessage &&
        (!location.pathname.includes('createFromExisting') ||
          localPpsiCopy !== 'true') && (
          <PpsiIfoodDiscontinueText
            text={displayText.dishiFoodDiscontinueText}
          />
        )}
      {!disableIfoodImportButton &&
        deactivateGlobalButton &&
        notShowMessage &&
        !location.pathname.includes('createFromExisting') &&
        localPpsiCopy !== 'true' && (
          <PpsiIfoodDiscontinueText
            text={displayText.globalPpsiDiscontinueText}
          />
        )}
      {!disableIfoodImportButton &&
        deactivateGlobalButton &&
        marketLanguage && <GlobalPpsiDiscontinueText />}

      {duplicatedPpis.length > 0 && (
        <PpsiIfoodDiscontinueText
          text={displayText.duplicatePpiText}
          customStyle={{ width: '320px', fontSize: '14px' }}
        />
      )}
      <PublishedInstructionLink data={data} visible={inStatus(States.DRAFT)} />
      <LanguageSelect marketLanguage={marketLanguage} />
      <Button
        label="form.ppsiIfoodUpdateButtonLabel"
        onClick={oniFoodUpdatePpsi}
        visible={isiFoodUpdateBtnVisible()}
        btnDisabled={disableIfoodImportButton || duplicatedPpis.length}
      />
      <Button
        label="form.ppsiIfoodGlobalButtonLabel"
        onClick={onGlobalUpdatePpsi}
        visible={isGlobalUpdateBtnVisible()}
        btnDisabled={deactivateGlobalButton}
        deactivateGlobalButton={deactivateGlobalButton}
      />
      <Button
        label="form.saveButtonLabel"
        onClick={onSave}
        visible={
          mode === Mode.CREATE ||
          inStatus(States.DRAFT) ||
          globalReject ||
          globalApprove
        }
        btnDisabled={displaySaveButton}
      />
      <Button
        label="form.sentReviewButtonLabel"
        onClick={onSubmitForReview}
        visible={globalReject || sentForReview}
        btnDisabled={displayCategory.length > 0}
        requireSavedData
      />
      <Button
        label="form.publishButtonLabel"
        onClick={onApprove}
        visible={(inStatus(States.DRAFT) && !sentForReview) || globalApprove}
        btnDisabled={displaySaveButton}
        requireSavedData
      />
      <Button
        label="form.rejectButtonLabel"
        onClick={onGlobalRejectPpsi}
        visible={marketLanguage}
        requireSavedData
      />
      <Button
        label="form.globalApproveButtonLabel"
        onClick={onGlobalApprovePpsi}
        visible={marketLanguage}
        btnDisabled={disableIfoodImportButton || deactivateGlobalButton}
        requireSavedData
      />
      <Button
        label={displayPublishedLabel()}
        //   label="form.createDraftPpsiLabel"
        onClick={onCreateDraft}
        visible={inStatus(
          States.PUBLISHED,
          States.UNPUBLISHED,
          States.SCHEDULED,
          !isGlobalUser ? States.GLOBALREVIEW : ''
        )}
        btnDisabled={disableEditInstructionBtn}
      />
      <Button
        label="form.publishButtonLabel"
        onClick={onPublish}
        visible={inStatus(States.SCHEDULED)}
        btnDisabled={checkStatus}
        requireSavedData
      />
      <MoreMenu visible={inStatus(States.PUBLISHED)}>
        <MoreMenuItem
          key="unpublish"
          onClick={onUnpublish}
          visible={inStatus(States.PUBLISHED)}
        >
          <FormattedMessage id="ppsi.unpublishMenuItemLabel" />
        </MoreMenuItem>
        <MoreMenuItem
          key="createvariant"
          onClick={createVariant}
          visible={!isGlobalUser && inStatus(States.PUBLISHED)}
        >
          <FormattedMessage id="ppsi.createVariantLabel" />
        </MoreMenuItem>
      </MoreMenu>
      <MoreMenu
        visible={
          inStatus(States.DRAFT) ||
          isDiscardScheduled ||
          globalReject ||
          globalApprove
        }
      >
        <MoreMenuItem
          key="discarddraft"
          onClick={() => setOpenConfirm(true)}
          visible={
            inStatus(States.DRAFT) ||
            isDiscardScheduled ||
            globalReject ||
            globalApprove
          }
        >
          <FormattedMessage
            id={
              isDiscardScheduled
                ? 'ppsi.discardScheduledLabel'
                : 'ppsi.discardDraftLabel'
            }
          />
          {/* //discardScheduledLabel */}
        </MoreMenuItem>
        <MoreMenuItem
          key="createvariant"
          onClick={createVariant}
          visible={
            !isGlobalUser &&
            (inStatus(States.DRAFT) || globalReject || globalApprove)
          }
        >
          <FormattedMessage id="ppsi.createVariantLabel" />
        </MoreMenuItem>
        {/* adding this for IFPPSI-954 stories and remove when its not required (Line no. 330 to 336) */}

        <MoreMenuItem
          key="publishEmptyTemplate"
          onClick={onPublishEmptyPpsi}
          visible={isGlobalUser && inStatus(States.DRAFT)}
          requireSavedData
        >
          <FormattedMessage id="ppsi.publishEmptyPpsiLabel" />
        </MoreMenuItem>
      </MoreMenu>
      <MoreMenu
        visible={
          !isGlobalUser &&
          inStatus(States.UNPUBLISHED) &&
          !iFoodDiscontinuedMessage &&
          !isItemDiscontinued
        }
      >
        <MoreMenuItem
          key="createvariant"
          onClick={createVariant}
          visible={!isGlobalUser && inStatus(States.UNPUBLISHED)}
        >
          <FormattedMessage id="ppsi.createVariantLabel" />
        </MoreMenuItem>
      </MoreMenu>
    </>
  );
};

PpsiToolbarContent.propTypes = {
  data: PropTypes.object,
  mode: modePropType.isRequired,
  onSave: PropTypes.func,
  onApprove: PropTypes.func,
  onPublish: PropTypes.func,
  onUnpublish: PropTypes.func,
  onCreateDraft: PropTypes.func
};

export default PpsiToolbarContent;
